import { FunctionComponent, ReactNode, useEffect } from "react";
import { LucideIcon, X } from "lucide-react";
import "./Modal.scss";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    /** Icone exibido no header */
    icon?: LucideIcon;
    /** Titulo do modal */
    title: ReactNode;
    /** Subtitulo / descricao */
    subtitle?: ReactNode;
    /** Largura maxima do conteudo (default 480px) */
    maxWidth?: number | string;
    /** Conteudo (form) */
    children: ReactNode;
    /** Botoes do rodape */
    footer?: ReactNode;
    /** Classe extra no body */
    className?: string;
    /** Fechar ao clicar no backdrop (default true) */
    closeOnBackdrop?: boolean;
}

const Modal: FunctionComponent<ModalProps> = ({
    open,
    onClose,
    icon: Icon,
    title,
    subtitle,
    maxWidth = 480,
    children,
    footer,
    className = "",
    closeOnBackdrop = true,
}) => {

    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="ui-modal" role="dialog" aria-modal="true">
            <div
                className="ui-modal-backdrop"
                onClick={closeOnBackdrop ? onClose : undefined}
            />
            <div
                className={`ui-modal-body page-card ${className}`.trim()}
                style={{ maxWidth }}
            >
                <button type="button" className="ui-modal-close" onClick={onClose} aria-label="Fechar">
                    <X size={18} />
                </button>

                <header className="ui-modal-header">
                    <h1>
                        <span>
                            {Icon && <Icon size={20} className="ui-modal-icon" />}
                            {title}
                        </span>
                    </h1>
                    {subtitle && <small>{subtitle}</small>}
                </header>

                <div className="ui-modal-content">
                    {children}
                </div>

                {footer && <footer className="ui-modal-footer">{footer}</footer>}
            </div>
        </div>
    );
};

export default Modal;
